const IMPORT_JOB_TIMESTAMP_FORMAT: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
};

export const formatImportJobTimestamp = (
    timestamp: string | null | undefined,
): string | null => {
    if (!timestamp) {
        return null;
    }

    const parsed = new Date(timestamp);
    if (Number.isNaN(parsed.getTime())) {
        return null;
    }

    return new Intl.DateTimeFormat('en-US', IMPORT_JOB_TIMESTAMP_FORMAT).format(
        parsed,
    );
};
